import { createTheme } from '@mui/material/styles'
import { brand } from './palette.js'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brand.red,
      dark: brand.redDark,
      light: brand.redSoft,
      contrastText: '#ffffff',
    },
    error: {
      main: brand.formError,
    },
    text: {
      primary: brand.ink,
      secondary: brand.muted,
    },
    divider: brand.line,
    background: {
      default: brand.bg,
      paper: '#ffffff',
    },
  },
  // Exposed for one-off sx lookups (`theme.custom.formPrimary`) where a
  // component needs the mockup's secondary form-page maroon instead of the
  // landing page's primary red.
  custom: brand,
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontFamily: '"Fraunces", Georgia, "Times New Roman", serif',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      // Reserves the scrollbar's width on every route, even pages short
      // enough to not need one — otherwise the sticky header (and all
      // centered content) shifts sideways by the scrollbar's width when
      // navigating between a scrolling and a non-scrolling page.
      styleOverrides: {
        html: {
          scrollbarGutter: 'stable',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
        },
      },
    },
  },
})

export default theme
